export default {
  messages: {
    en: {
      label: 'Angel',
    },
  },
}
